import { render, staticRenderFns } from "./MultiDuplicates.vue?vue&type=template&id=0bf6a492&"
import script from "./MultiDuplicates.vue?vue&type=script&lang=js&"
export * from "./MultiDuplicates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports